export default __webpack_public_path__ + "static/media/gmail.41ec9dfc.svg";